<template>
    <div class="page">
        <div class="main_body">
            <div class="top_label">
                <span class="lable_name">自主学习</span>

            </div>
            <div class="work_statistics_box">
                <div class="work_statistics_title"> 
                    <i class="el-icon-stopwatch"></i>
                    <span>学习统计</span>
                </div>
                
                <div class="work_statistics">
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">今日练习</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{statistics_data.today_number}}篇</span>
                                <span style="color:#F56C6C" class="statistics_item_left_diff">正确率 {{statistics_data.today_average_score}}%</span>
                            </div>
                            
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                <i class="el-icon-s-opportunity"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">学习篇数</span>
                            <span class="statistics_item_left_num">{{statistics_data.total_number}}篇</span>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color: #D9ECFF;color: #409EFF;">
                                <i class="el-icon-reading"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">平均正确率</span>
                            <span class="statistics_item_left_num">{{statistics_data.average_score}}%</span>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color: #FDE2E2;color: #F56C6C;">
                                <i class="el-icon-check"></i>
                            </span>
                        </div>
                    </div>

                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">学习时长</span>
                            <span class="statistics_item_left_num">{{statistics_data.total_time}}</span>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color: #F0F9EB;color: #67C23A;">
                                <i class="el-icon-alarm-clock"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">阅读在线</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{statistics_data.read_number}}篇</span>
                                <span style="color:green" class="statistics_item_left_diff">正确率 {{statistics_data.read_average_score}}%</span>
                            </div>
                            
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                <i class="el-icon-monitor"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">应试英语</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{statistics_data.specatily_number}}篇</span>
                                <span style="color:green" class="statistics_item_left_diff">正确率 {{statistics_data.specatily_average_score}}%</span>
                            </div>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                <i class="el-icon-edit"></i>
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="work_statistics_box">
                <div class="work_statistics_title"> 
                    <i class="el-icon-edit"></i>
                    <span>学习记录</span>
                </div>

                <div class="work_history">
                    <div @click="mapdetail(item)" class="work_history_list" v-for="(item,index) in study_list" :key="index">
                        <span class="list_title">{{item.title}}</span>
                        <span class="list_time">{{item.createtime}}</span>
                        <span class="list_tag">{{item.table_type_text}} - {{item.grade_text}}</span>
                        <div class="work_history_list_statistics">
                            <div class="list_statistics_left">
                                <span class="list_statistics_item_left_title">正确率</span>
                                <span style="color:#F56C6C" class="list_statistics_item_left_num">{{item.score}}%</span>
                            </div>
                            <div class="list_statistics_right">
                                <span class="list_statistics_item_left_title">用时</span>
                                <span style="color:#409EFF" class="list_statistics_item_left_num">{{item.time}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <el-empty v-if="!study_list.length" description="暂无学习记录"></el-empty>

                <div v-if="study_count > form_data.pageSize" class="work_history_pagination">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="form_data.pageSize"
                        :hide-on-single-page="true"
                        @prev-click="prev"
                        @next-click="next"
                        @current-change="currentChange"
                        :total="study_count">
                    </el-pagination>
                </div>
            </div>
  
        </div>
    </div>
</template>
<script>
import Http from "../../apis/student";
export default {

    data(){
        return{
            form_data:{
                page:1,
                pageSize:15
            },
            statistics_data:{},
            study_list:[],
            study_count:0
        }
    },
    created(){
        this.getData()
        this.getStatistics()
    },
    methods:{
        getData(){
            Http.studySelfList(this.form_data).then((res) => {
                this.study_list = res.data.list
                this.study_count = res.data.count
            });
        },
        getStatistics(){
            Http.studySelfStatistics().then((res) => {
                this.statistics_data = res.data
            });
        },
        prev(){
            this.form_data.page--
            this.getData()
        },
        next(){
            this.form_data.page++
            this.getData()
        },
        currentChange(val){
            this.form_data.page = val
            this.getData()
        },
        mapdetail(item){

            if(item.table_type == 'read'){
                this.$router.push({name:'ReadDetail',query:{id:item.w_id}});
            }else{
                this.$router.push({name:'SpecialtyDetail',query:{id:item.w_id,type:item.z_type}});
            }
        }
    }
}
</script>
<style scoped>

.top_label{
    display: flex;
    justify-content: flex-start;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}
.work_statistics{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
    
    
}

.statistics_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.statistics_item_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
}
.statistics_item_left_title{
    font-weight: 700;
}
.statistics_item_left_num{
    font-size: 14px;
    font-weight: 700;
}
.statistics_item_right_icon{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #D9ECFF;
    color: #409EFF;
}
.work_statistics_box{
    display: inline-block;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    
    margin-top: 25px;
}
.work_statistics_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 20px;
}
.work_statistics_title span{
    font-weight: 700;
}
.work_statistics_title i{
    
    color: #409EFF;
}
.statistics_item_left_num_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
}
.statistics_item_left_diff{
    font-size: 12px;
}
.work_history{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 25px;
}
.work_history_list{
    display: inline-block;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    cursor: pointer;
    transition: all 0.3s ease;
}
.work_history_list:hover{
    box-shadow: 0 8px 20px rgba(64, 158, 255, 0.2);
    transform: translateY(-5px);
}
.work_history_list_statistics{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
}

.list_title{
    width: 100%;
    display: inline-block;
    font-weight: 700;
    text-align: left;
    font-size: 15px;
}
.list_time{
    display: inline-block;
    width: 100%;
    font-size: 14px;
    line-height: 35px;
}
.list_tag{
    display: inline-block;
    width: 100%;
    font-size: 14px;
    line-height: 30px;
}
.statistics_item_left_title{
    font-size: 16px;
}
.statistics_item_left_num{
    font-size: 14px;
}
.list_statistics_left{
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #f8f9fa;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
}
.list_statistics_right{
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #f8f9fa;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
}
.list_statistics_item_left_title{
    font-size: 14px;
}
.list_statistics_item_left_num{
    font-size: 16px;
    font-weight: 700;
}
.work_history_pagination{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    background: #fff;
    padding: 20px 0;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
</style>